import { render, staticRenderFns } from "./report-actions.vue?vue&type=template&id=2a6df9e8&"
import script from "./report-actions.vue?vue&type=script&lang=ts&"
export * from "./report-actions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports